/**
 * Marker character (zero-width space) used to wrap acronyms that should be
 * preserved as Latin (e.g., "SEF", "POPDV"). Wrap on both sides:
 *   `${ACRONYM_MARKER}SEF${ACRONYM_MARKER}`
 */
export const ACRONYM_MARKER = "\u200B";

/**
 * Map of digraphs (must be applied before single characters).
 * Order: lowercase, Title-case, UPPERCASE.
 */
const DIGRAPHS: Array<[string, string]> = [
  ["lj", "љ"],
  ["nj", "њ"],
  ["dž", "џ"],
  ["Lj", "Љ"],
  ["Nj", "Њ"],
  ["Dž", "Џ"],
  ["LJ", "Љ"],
  ["NJ", "Њ"],
  ["DŽ", "Џ"],
];

const SINGLES: Record<string, string> = {
  a: "а", b: "б", c: "ц", č: "ч", ć: "ћ", d: "д", đ: "ђ", e: "е", f: "ф", g: "г",
  h: "х", i: "и", j: "ј", k: "к", l: "л", m: "м", n: "н", o: "о", p: "п", r: "р",
  s: "с", š: "ш", t: "т", u: "у", v: "в", z: "з", ž: "ж",
  A: "А", B: "Б", C: "Ц", Č: "Ч", Ć: "Ћ", D: "Д", Đ: "Ђ", E: "Е", F: "Ф", G: "Г",
  H: "Х", I: "И", J: "Ј", K: "К", L: "Л", M: "М", N: "Н", O: "О", P: "П", R: "Р",
  S: "С", Š: "Ш", T: "Т", U: "У", V: "В", Z: "З", Ž: "Ж",
};

function transliterateSegment(input: string): string {
  let out = input;
  // Apply digraphs first
  for (const [from, to] of DIGRAPHS) {
    out = out.split(from).join(to);
  }
  // Then single chars
  let result = "";
  for (const ch of out) {
    result += SINGLES[ch] ?? ch;
  }
  return result;
}

export function latnToCyrl(input: string): string {
  // Split on the acronym marker; even-indexed segments are transliterated,
  // odd-indexed (between markers) are kept as-is.
  const parts = input.split(ACRONYM_MARKER);
  return parts.map((p, i) => (i % 2 === 0 ? transliterateSegment(p) : p)).join("");
}
